module.exports = __webpack_public_path__ + "static/loonshots-eff5cb59f641109785be4ebb867deddf.jpg";